import React from 'react'
import NotFound from 'components/not-found/not-found.component'
import useStyles from './not-found-container.style'

const NotFoundContainer = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <NotFound />
    </div>
  )
}

export default NotFoundContainer
